<template>
  <b-form-group
    label="Termin Süresi"
    label-for="deadline"
  >
    <validation-provider
      #default="{ errors }"
      name="Termin Süresi"
      rules="required"
    >
      <b-form-input
        id="deadline"
        v-model="dataItem.deadline"
        placeholder="Termin Süresi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'Deadline',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
